var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import * as types from './types';

export default function docs() {
  var _extends2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var location = action.location;


  switch (action.type) {
    case types.VALUE_CHANGED:
      return _extends({}, state, (_extends2 = {}, _extends2[location] = action.payload, _extends2));

    case types.DESTROY:
      var omitData = state[location],
          rest = _objectWithoutProperties(state, [location]);

      return _extends({}, rest);

    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/firekit/es/store/docs/reducer.js
// module id = 292
// module chunks = 49